var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRvp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.423 13.877 1 7.538h3.98c.221.05.664-.007.664-.626 0-.408-.184-.509-.358-.605-.157-.086-.306-.168-.306-.464 0-.501.443-.651.664-.664h5.97L10.62 4h3.648l3.39 4.68h5.97c1.831.025 5.492 1.26 5.492 6.008 0 4.747-3.66 5.91-5.49 5.897h-5.013v7.26h-3.354V13.251l3.354 4.57h1.806l-4.497-6.338h-4.312a.714.714 0 0 0-.295.59c0 .212.162.435.316.647.14.19.273.373.273.53 0 .266-.394.529-.59.627H5.422zm17.911 8.293 4.128 5.675H31l-4.496-6.486c-.197.072-.745.279-1.364.515-.62.236-1.462.295-1.806.295zm.627-4.497-4.274-6.191h3.058c.885.024 2.757.56 3.17 2.506.516 2.432-1.216 3.464-1.953 3.685z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRvp);
export default __webpack_public_path__ + "static/media/RVP.357bdb5ddef24e38d6cc318c4d02040f.svg";
export { ForwardRef as ReactComponent };